export type SurveySidebarBaseState = {
  baseIsCollapsed: boolean;
  baseIsContextCollapsed: boolean;
};
export type SurveySidebarToggleTarget = 'left' | 'right';
export type SurveySidebarViewportMode = 'desktop' | 'mobile' | 'tablet';

export type SurveySidebarState = {
  isCollapsed: boolean;
  isContextCollapsed: boolean;
};

type ResolveSurveySidebarBaseStateForSetParams = SurveySidebarBaseState & {
  collapsed: boolean;
  target: SurveySidebarToggleTarget;
  viewportMode: SurveySidebarViewportMode;
};

type ResolveSurveySidebarBaseStateForToggleParams = SurveySidebarBaseState & {
  target: SurveySidebarToggleTarget;
  viewportMode: SurveySidebarViewportMode;
};

export function resolveSurveySidebarViewportMode(params: {
  isMobile: boolean;
  isTablet: boolean;
}): SurveySidebarViewportMode {
  const { isMobile, isTablet } = params;

  if (isMobile) {
    return 'mobile';
  }

  if (isTablet) {
    return 'tablet';
  }

  return 'desktop';
}

export function resolveSurveySidebarState(
  params: SurveySidebarBaseState & { viewportMode: SurveySidebarViewportMode },
) {
  const { baseIsCollapsed, baseIsContextCollapsed, viewportMode } = params;

  if (viewportMode === 'mobile') {
    return {
      isCollapsed: true,
      isContextCollapsed: true,
    };
  }

  if (viewportMode === 'tablet' && !baseIsCollapsed && !baseIsContextCollapsed) {
    return {
      isCollapsed: false,
      isContextCollapsed: true,
    };
  }

  return {
    isCollapsed: baseIsCollapsed,
    isContextCollapsed: baseIsContextCollapsed,
  };
}

export function resolveSurveySidebarBaseStateForSet(
  params: ResolveSurveySidebarBaseStateForSetParams,
): SurveySidebarBaseState {
  const { baseIsCollapsed, baseIsContextCollapsed, collapsed, target, viewportMode } = params;

  if (viewportMode === 'mobile') {
    return {
      baseIsCollapsed,
      baseIsContextCollapsed,
    };
  }

  if (target === 'left') {
    if (viewportMode === 'tablet') {
      return {
        baseIsCollapsed: collapsed,
        baseIsContextCollapsed: true,
      };
    }

    return {
      baseIsCollapsed: collapsed,
      baseIsContextCollapsed,
    };
  }

  if (viewportMode === 'tablet') {
    return {
      baseIsCollapsed: true,
      baseIsContextCollapsed: collapsed,
    };
  }

  return {
    baseIsCollapsed,
    baseIsContextCollapsed: collapsed,
  };
}

export function resolveSurveySidebarBaseStateForToggle(
  params: ResolveSurveySidebarBaseStateForToggleParams,
): SurveySidebarBaseState {
  const { baseIsCollapsed, baseIsContextCollapsed, target, viewportMode } = params;
  const effectiveState = resolveSurveySidebarState({
    baseIsCollapsed,
    baseIsContextCollapsed,
    viewportMode,
  });

  if (target === 'left') {
    return resolveSurveySidebarBaseStateForSet({
      baseIsCollapsed,
      baseIsContextCollapsed,
      collapsed: !effectiveState.isCollapsed,
      target,
      viewportMode,
    });
  }

  return resolveSurveySidebarBaseStateForSet({
    baseIsCollapsed,
    baseIsContextCollapsed,
    collapsed: !effectiveState.isContextCollapsed,
    target,
    viewportMode,
  });
}
